import React from 'react';
import AcquisitionOptions from './AcquisitionOptions/AcquisitionOptions';
import DeliveryOption from './AcquisitionOptions/DeliveryOption';
import PickUpOption from './AcquisitionOptions/PickupOption';

import Cta from './Cta';

import CityStateInfo from './LocationDisplay/CityStateInfo';
import LocationDisplay from './LocationDisplay/LocationDisplay';

import LocationInputForm from './LocationInputForm/FormWrapper';

import { useLocationContext } from '../context/LocationContext';
import getFormHeading from '../lib/getFormHeading';
import maybeErrored from '../lib/maybeErrored';

export default function DeliverableContent() {
  const {
    isDeliveryAllowed = true,
    errorState,
    isExcludedLocation
  } = useLocationContext();
  const hasErrored = maybeErrored(errorState);
  const formHeading = getFormHeading({
    hasErrored,
    isExcludedLocation,
    isDeliveryAllowed
  });

  return isDeliveryAllowed ? (
    <>
      <Cta ctaText="Enter Your ZIP Code" />
      <LocationInputForm formHeading={formHeading} />
      <LocationDisplay>
        <CityStateInfo />
        <AcquisitionOptions>
          <PickUpOption />
          <DeliveryOption />
        </AcquisitionOptions>
      </LocationDisplay>
    </>
  ) : null;
}
